import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import { IconButton } from '../../helpers/IconButton';

import style from './style.module.css';

/**
 * Plus button that adds the entered value as a tag in a Browse form filter.
 *
 * @param props {Object}.
 * @param props.onClick {Function} Handle button click.
 */
const BrowseAddTagButtonComponent = ({ onClick }) => (
  <div className={classNames(style.host, 'form-group')}>
    <IconButton icon="plus" onClick={onClick} title="Add filter" variant="primary" />
  </div>
);

BrowseAddTagButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const BrowseAddTagButton = memo(BrowseAddTagButtonComponent);
